/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import AddToCart from './AddToCart';
import SaveToCloset from './SaveToCloset';
import Promotions from './Promotions';
import SizeGuide from './SizeGuide';
import ColorVariant from './ColorVariant';
import SizeVariant from './SizeVariant';
// import ProductPriceReveal from './ProductPriceReveal';
import ProductPriceRevealV2 from './ProductPriceRevealV2';
import { getSizeData } from '../../../actions/productData';

import { addProductToWishlist } from '../../../wishlist/actions/wishlist';
import { generateEvent } from '../../../utils/dataGrinch';
import Modal from '../../common/Modal';
import { showModal, hideModal, updateModal } from '../../../actions/shared/modal';
import DropAtStoreInfo from '../../../myaccount/components/responsive/DropAtStoreInfo';
import BestPriceSectionInfo from '../../common/BestPriceSectionInfo';
import { EstimatedDeliveryDate } from '../../../edd/index';
import { signInCheck } from '../../common/CheckUserStatus';
import * as actions from '../../../actions/productData';
import { IsDealStart, IsDealEnd } from '../../common/DodCommonComponent/DodComponentFunctionality';
import { DealOfTheDayTimerTag } from '../../common/DodCommonComponent/DodCommonComponent';
import { DealOfTheDayModal } from '../../common/DodCommonComponent/DodModals';
import { dodTimerId } from '../../common/DodCommonComponent/DodCommonComponent';
import {
  getProductCatalog,
  getSnekaerHoodData,
  getBrickCode,
  getSectionOne,
  getSectionTwo,
  getSectionThree,
  getFeatureData,
  getJioAddData,
  getProductSubCategory,
  getSizeRecommendFetch,
  getEmiDetails,
  renderEMITemplate,
  getServiceabilityDetailsDetails
} from '../../../refresh/selectors/productpage';
import {
  getEarlyAccessFlag,
  getEarlyAccessData,
  getDisableGSTContentFlag,
  getDefaultGSTMessage,
  getNewSizeRevampDesktopFlag,
  getShowBrandSizeDesktopFlag,
  getSizeRecommendFlag,
  getHurryMsgInvCap,
  getPriceRevealWebFlag,
  getPriceRevealV2WebFeatureFlag,
  getPriceRevealWebData,
  getPriceRevealLUXEFlag
} from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import {
  getVolumeAndSizeFlag,
  filterTrustmarkerImage,
  getIsPriceRevealPDP,
  getSaleDuration
} from '../../../utils/pdp';
import {
  gtmPagePush,
  gtmEventPush,
  luxeGtmProductDetailView,
  gtmProductDetailView,
  gtmDatalayerPushData,
  getStoreName,
  getUserUUID,
  segmentEventPush,
  getProductItemPDP
} from '../../../modules/ga/GTMdatalayer';
import { setAdditionalInfo } from '../../../actions/shared/productsData';
import properties from '../../../modules/ajio-util/properties';
import { DURING_SALE, PRE_BUZZ, SHOW_MRP_TEXT } from '../../common/PriceRevealPLPBanner/messages';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { displayValueWithSymbol } from '../../../utils/price';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import { jioAdsProductViewEvent, deeplinkLaunchEvent } from '../../../utils/jioAds';
import { getTagValueFromTagEngine, getPriceLableFromTagEngine } from '../../../utils/product';
import { isCatalogNameInFirebaseStore , getValidAttributionToken, isCopilotReferrer} from '../../../utils/common';
import { getVariant, getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import { checkEarlyAccessUser } from '../../common/Cookie';
import {
  getSingleRecommend,
  getShowPDPRateSection,
  getEnableRating,
  getStoresForHidingMRP,
  getGA4AJIOEnable,
  getGiftWithProductEnable,
  getGiftWithProductConfig,
  getRatingsColorConfig,
  getEnableComingSoonProducts,
  getDressToolPdpBannerConfig,
  getBrickCodeList,
  getBetterPdpConfigFlag,
  getSectionOneTabularViewFlag,
  getSectionTwoTabularViewFlag,
  getSectionThreeTabularViewFlag,
  getMaxKeyValuePairFlag,
  getMaxLineForValueFlag,
  getBetterPdpTitleFlag,
  getAjioSuperCashPdpEnable,
  getAjioSuperCashConfig,
  getEmiDiscountEnable,
  getEmiTemplate,
  getEmiThresholdAmount,
  getOfferCardOrder,
  getEmiDiscountEnableForPDP
} from '../../../refresh/selectors/featureFlagsSelector';
import RatingLabel from '../../../refresh/atoms/RatingLabel';
import Freebies from '../../../components/common/Freebies';
import { getGAFreebiesText } from '../../common/Freebies/FreebiesCommon';
import { dressToolInitiateInitialFlag } from '../../../actions/shared/braRecommendation';
import {
  showModal as showDressToolModal,
  hideModal as hideDressToolModal
} from '../../../actions/modal';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import SizeRecommendation from '../../../refresh/organism/SizeSelector/SizeRecommendation'


const imageBaseUrl = properties.getProperty('imageBaseUrl');
const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;

const isSignedIn = signInCheck();
const displayGSTMessage = (self = {}, boolGST, displayformattedValue = '', colorVariant) => {
  let message = '';
  const {
    textContent: { additionalGST = '' } = {},
    props: { disableGSTContent, defaultGSTMessage = '' } = {}
  } = self;

  const { isThisJewelleryItem = false } = getVolumeAndSizeFlag(colorVariant);
  switch (disableGSTContent.toLowerCase()) {
    case '':
      message = '';
      break;
    case 'on':
      message = defaultGSTMessage;
      break;
    case 'off':
      message = isThisJewelleryItem ? '' : boolGST ? displayformattedValue : additionalGST;
      break;
    default:
      message = '';
      break;
  }
  return message ? (
    <div className="prod-gst" aria-label={message}>
      {message}
    </div>
  ) : null;
};

class Description extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSliderOpen: false,
      stockList: [],
      sizeGuide: '',
      inches: '',
      inchesIntConv: '',
      defaultUnit: '',
      hideToggle: false,
      gstPrice: '',
      isDealStock: false,
      productDealCode: '',
      showClaim: false,
      initialDeal: {},
      priveReveal: { btn: '', shownToUser: false },
      isJioAdsLoaded: true,
      superCashEarning: ''
    };
    this.sizeGuide = '';
    this.mUnit = '';
    (this.dodCode = ''),
      (this.newSize = {
        sizeType: '',
        sizeTypeLabel: ''
      });
    this.showBrandFormat = '';
    this.newSizeFormat = '';
    this.textContent = {
      additionalGST: 'Additional GST may apply'
    };
    // this.isPriceReveal = false;
    this.isPriceRevealV2 = false;
    this.saveToCloset = this.saveToCloset.bind(this);
    this.revealPriceCH = this.revealPriceCH.bind(this);
    this.priceRevealSaveToClosetCH = this.priceRevealSaveToClosetCH.bind(this);
    this.priceRevealGoToClosetCH = this.priceRevealGoToClosetCH.bind(this);
  }

  handleToggleInchCM = () => {
    const { productData, newDesignLuxe } = this.props;
    let { code: prodCode = '', name } = productData || {};
    this.setState(prevState => {
      return {
        ...prevState,
        inches: !prevState.inches,
        defaultUnit: !prevState.defaultUnit
      };
    });
    const inches = this.state.inches;
    gtmEventPush({
      event: 'size_chart_interaction',
      event_category: 'size chart interactions',
      event_action: !inches ? 'in' : 'cm',
      product_name: name,
      product_id: prodCode,
      page_type: screenType,
      page_name: screenName,
      store_type: newDesignLuxe ? 'luxe' : 'ajio'
    });

    // Segment Push Event
    segmentEventPush({
      event: 'Size Chart Interactions',
      event_category: 'size chart interactions',
      event_action: !inches ? 'in' : 'cm',
      inch_or_cm_flag:  !inches ? 'in' : 'cm',
      interaction_description:'ToggleInchCM', 
      products:[{
         ...getProductItemPDP(productData), 
      }],
      screen_name: screenName,
      store_type: newDesignLuxe ? 'luxe' : 'ajio',
      size_selected_in_radio:''
    });
  };

  handleToggleInchCMIntConv = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        inchesIntConv: !prevState.inchesIntConv,
        defaultUnit: !prevState.defaultUnit
      };
    });
  };

  updateStaticData = () => {
    const {
      productData: { fnlColorVariantData: { sizeGuideDesktop = {} } = {} } = {}
    } = this.props;
    const sizeChartData = !isEmpty(sizeGuideDesktop) && JSON.parse(sizeGuideDesktop);
    const { productData = {} } = this.props;
    const sizeType = _get(productData, 'variantOptions[0].sizeDisplayType', '');
    const newSizeFormat = _get(productData, 'variantOptions[0].displaySizeFormat', '');
    const brickBrandSizes = _get(sizeChartData, 'sizechart[0].brickBrandSizes[0].sizeChartAttributes', '')
    const sizeFormatText = _find(brickBrandSizes, { attributeName: "Universal Size Format_attribute" });
    this.newSizeFormat = sizeFormatText?.attributeValue ? sizeFormatText?.attributeValue : newSizeFormat !== 'UNI' ? newSizeFormat : '';
    this.newSize = {
      sizeType,
      sizeTypeLabel: sizeType === 'STANDARD' ? 'Brand Size ' : ''
    };
  };

  getPriceRevealV2Data = () => {
    const {
      bbsPriceStaticText = '',
      luxebbsPriceStaticText = '',
      bbsSaleStartText,
      userEduText = '',
      luxeUserEduText = '',
      priceComingSoonTxt = '',
      luxePriceComingSoonTxt = '',
      bannerImgSrc = {},
      luxeBannerImgSrc = {},
      hamperImgSrc = {}
    } = this.props?.priceRevealV2WebData || {};
    const { productData, newDesignLuxe } = this.props || {};
    const { saleStartTime, saleEndTime, futureBestPrice, futureDiscountPercent, price } =
      productData || {};
    const saleDuration = getSaleDuration(saleStartTime, saleEndTime);

    if (this.isPriceRevealV2) {
      return {
        saleDuration,
        title: newDesignLuxe ? luxebbsPriceStaticText : bbsPriceStaticText,
        description: newDesignLuxe
          ? `Start on ${moment(saleStartTime, 'X').format('MMMM D, h:mm a')}`
          : bbsSaleStartText,
        cta: true,
        futureBestPrice,
        price,
        discountValue: futureDiscountPercent,
        userEduText: newDesignLuxe ? luxeUserEduText : userEduText,
        priceComingSoonTxt: newDesignLuxe ? luxePriceComingSoonTxt : priceComingSoonTxt,
        bannerImgSrc: newDesignLuxe ? luxeBannerImgSrc : bannerImgSrc,
        hamperImgSrc
      };
    }
  };

  showPriceRevealPreBuzz = () => {
    const { productData } = this.props || {};
    const { saleStartTime, saleEndTime, futureBestPrice } = productData || {};
    const saleDuration = getSaleDuration(saleStartTime, saleEndTime);
    return futureBestPrice && saleDuration === PRE_BUZZ;
  };

  showPriceRevealOnPromotions = () => {
    const { saleStartTime, saleEndTime } = this.props?.productData || {};
    const saleDuration = getSaleDuration(saleStartTime, saleEndTime);
    if (saleDuration === DURING_SALE && this.isPriceRevealV2) {
      return true;
    }
    return false;
  };

  showPriceRevealOnPromotions = () => {
    const { saleStartTime, saleEndTime } = this.props?.productData || {};
    const saleDuration = getSaleDuration(saleStartTime, saleEndTime);
    if (saleDuration === DURING_SALE && this.isPriceRevealV2) {
      return true;
    }
    return false;
  };

  // getIsPriceReveal = (selectedSizeCode, productData, priceRevealWebFlag) => {
  //   const { price: { priceReveal } = {}, variantOptions = [], baseOptions=[], code: prodCode='' } = productData || {};
  //   let priceRevealVariantData = priceReveal;
  //   const defaultSelectedSize = baseOptions.filter(variant => {
  //     const {selected: {code} = {}} = variant || {};
  //     return prodCode === code;
  //   });
  //   if(defaultSelectedSize && defaultSelectedSize.length > 0 && selectedSizeCode.length === 0) {
  //     const { selected: { priceData: { priceReveal } = {} } = {} } = defaultSelectedSize[0];
  //     priceRevealVariantData = priceReveal
  //   } else if (selectedSizeCode && selectedSizeCode.length > 0) {
  //     const sizeVariantLevelData = variantOptions.filter(item => item.code === selectedSizeCode);
  //     const selectedProductData = sizeVariantLevelData && sizeVariantLevelData.length ? sizeVariantLevelData[0] : {};
  //     const { priceData: { priceReveal } = {} } = selectedProductData;
  //     priceRevealVariantData = priceReveal;
  //   }
  //   const priceRevealData = priceRevealVariantData || {};
  //   const { description, discountValue, hashtag, imageBannerURL, price, title } = priceRevealData || {};
  //   if(priceRevealWebFlag && description && discountValue && hashtag && imageBannerURL && price && title) {
  //     return true;
  //   } else return false;
  // }

  // getPriceRevealData = () => {
  //   const { productData, selectedSizeCode } = this.props;
  //   let { price: { priceReveal } = {}, variantOptions, baseOptions=[], code: prodCode='' } = productData || {};
  //   let priceRevealData = priceReveal || {}
  //   const defaultSelectedSize = baseOptions.filter(variant => {
  //     const {selected: {code} = {}} = variant || {};
  //     return prodCode === code;
  //   });
  //   if(defaultSelectedSize && defaultSelectedSize.length > 0 && selectedSizeCode.length === 0) {
  //       const { selected: { priceData: { priceReveal } = {} } = {} } = defaultSelectedSize[0];
  //       priceRevealData = priceReveal
  //   } else if(selectedSizeCode && selectedSizeCode.length > 0) {
  //     const variantProductData = variantOptions.filter((item) => item.code === selectedSizeCode);
  //     const selectedProductData = variantProductData && variantProductData.length ? variantProductData[0] : {};
  //     const { priceData: { priceReveal } = {} } = selectedProductData;
  //     priceRevealData = priceReveal;
  //   }
  //   let { description,discountValue, hashtag, imageBannerURL, price, title } = priceRevealData || {};

  //   if(this.isPriceReveal) {
  //     if(price > 0) {
  //       return {
  //         description,
  //         discountValue,
  //         hashtag,
  //         imageBannerURL,
  //         price,
  //         cta:true,
  //         title
  //       }
  //     } else {
  //       return {
  //         description,
  //         hashtag,
  //         imageBannerURL,
  //         cta:false,
  //         price: "XX.XX",
  //         title: "Price revealing soon"
  //       }
  //     }
  //   }
  // }

  sendGTMEvent = label => {
    const { productData, selectedSizeCode, metadata = {} } = this.props;
    let { code: prodCode = '', url: productUrl = '' } = productData || {};
    gtmEventPush({
      event: 'bbs_widget_interaction',
      event_category: 'widget interaction',
      event_action: 'bbs widget',
      event_label: label || this.state.priveReveal.btn,
      product_id: selectedSizeCode || prodCode,
      screen_name: 'product page',
      store_type: metadata?.sis ? metadata.name : 'AJIO',
      user_status: signInCheck() ? 'logged in' : 'not logged In',
      login_type: signInCheck() ? 'logged in' : 'not logged In'
    });
  };

  revealPriceCH = isHalfCard => {
    const {
      productData,
      selectedSizeCode,
      metadata = {},
      setAdditionalInfo,
      newDesignLuxe
    } = this.props;
    let { code: prodCode = '', url: productUrl = '' } = productData || {};
    isHalfCard ? this.sendGTMEvent('reveal price - half card') : this.sendGTMEvent();
    const username = signInCheck();
    if (!localStorage.getItem('priceReveal_v2')) {
      localStorage.setItem('priceReveal_v2', true);
    }
    if (username) {
      setAdditionalInfo({
        isPriceReveal: (username && localStorage.getItem('priceReveal_v2')) || false
      });
      this.setState({
        priveReveal: {
          btn: newDesignLuxe ? 'ADD TO WISHLIST' : 'SAVE TO WISHLIST',
          shownToUser: true
        }
      });
      return;
    }
    window.location.href = `/login?referrer=${productUrl}&login_source=pdp - price reveal widget`;
  };

  priceRevealSaveToClosetCH = prodData => {
    const { productData, selectedSizeCode, metadata = {}, newDesignLuxe } = this.props;
    let { code: prodCode = '', name, brickCategory, brandName, verticalColor = '', price = {} } =
      productData || {};
    gtmEventPush({
      event: 'add_to_wishlist',
      event_category: 'pdp widget',
      event_action: 'price reveal widget',
      event_label: this.state.priveReveal.btn,
      click_text: this.state.priveReveal.btn,
      page_type: screenType,
      ecommerce: {
        products: [
          {
            name, // Name or ID is required.
            id: prodCode,
            price: price.value,
            brand: brandName,
            category: brickCategory,
            discount: price.discountPercentage,
            variant: verticalColor
          }
        ]
      }
    });
    // Send Segment
    segmentEventPush({
      event: 'Product Wishlisted',
      event_category: 'pdp widget',
      event_action: 'price reveal widget',
      event_label: this.state.priveReveal.btn,
      //click_text: this.state.priveReveal.btn,
      screen_type: screenType,
      wishlisted_source: 'price reveal widget',
      ecommerce: {
        items: [
          {
            ...getProductItemPDP(productData)
          }
        ]
      }
    });

    this.sendGTMEvent();
    this.saveToCloset(prodData);
    this.setState({
      priveReveal: { btn: newDesignLuxe ? 'GO TO WISHLIST' : 'GO TO CLOSET', shownToUser: true }
    });
  };

  priceRevealGoToClosetCH = () => {
    const { newDesignLuxe } = this.props;
    this.sendGTMEvent();
    this.setState(
      {
        priveReveal: { btn: newDesignLuxe ? 'GO TO WISHLIST' : 'GO TO WISHLIST', shownToUser: true }
      },
      () => {
        window.location.href = '/wishlist';
      }
    );
  };

  saveToCloset(prodData) {
    let { productData = {}, selectedSizeCode } = this.props;
    let sizeCode = selectedSizeCode || prodData;
    let { price: { formattedValue: Price = '' } = {}, baseProduct = '' } = productData;
    let isSignedIn = signInCheck();
    generateEvent({
      Event: 'AddToCloset',
      value: {
        SizeSelected: sizeCode,
        Quantity: 1,
        Price,
        ProductId: baseProduct
      }
    });
    if (isSignedIn) {
      this.props.addToWishlistApi(sizeCode);
    } else {
      this.props.showModal('sign-in-up');
    }
  }

  componentDidMount() {
    let {
      productData = {},
      productData: {
        baseProduct: productCode = '',
        seasonCode = ' ',
        brickCategory: gender = '',
        fnlProductData: { planningCategory = '' } = {},
        price: { discountValue = 0, value } = {},
        wasPriceData: { value: productMRP },
        potentialPromotions,
        variantOptions = [],
        stock = {},
        brickName,
        brickCategory,
        brandName,
        name: productName = ''
      } = {},
      newSizeRevampDesktopFlag = true,
      sizeRecommendFlag = false,
      priceRevealWebFlag,
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData,
      selectedSizeCode,
      metadata,
      priceRevealLUXEFlag,
      oosStatus,
      newDesignLuxe,
      currentStore,
      enableRating,
      showPDPRateSection,
      dressToolPdpBannerConfig,
      ga4AjioEnable
    } = this.props;
    if (stock.stockLevelStatus === 'outOfStock') {
      gtmEventPush({
        event: 'business_error',
        event_category: 'errors interactions',
        event_action: 'business_error',
        event_label: 'Size Out of Stock'
      });
    }
    const { sis, name } = metadata || {};
    const { bbsTextButton, luxeBbsTextButton } = priceRevealV2WebData || {};
    const { saleStartTime, saleEndTime } = productData;
    const loggedUsername = signInCheck();
    const duringBBSSale = getSaleDuration(saleStartTime, saleEndTime) === DURING_SALE;
    try {
      let priceRevealValue = false;
      if (duringBBSSale) {
        priceRevealValue = true;
      } else if (loggedUsername && localStorage.getItem('priceReveal_v2')) {
        priceRevealValue = true;
      }
      setAdditionalInfo({
        isPriceReveal: priceRevealValue
      });
      if (localStorage.getItem('priceReveal_v2') && loggedUsername) {
        this.setState({
          priveReveal: {
            btn: newDesignLuxe ? 'ADD TO WISHLIST' : 'SAVE TO WISHLIST',
            shownToUser: true
          }
        });
      } else {
        this.setState({
          priveReveal: {
            btn: newDesignLuxe ? luxeBbsTextButton : bbsTextButton,
            shownToUser: false
          }
        });
      }
    } catch (e) {
      console.log(e);
    }

    // this.isPriceReveal = this.getIsPriceReveal(selectedSizeCode, productData, priceRevealWebFlag);
    const store = sis ? name : 'AJIO';

    this.isPriceRevealV2 = getIsPriceRevealPDP(
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData,
      productData,
      store,
      priceRevealLUXEFlag
    );
    // const priceRevealData = this.getPriceRevealData()
    const priceRevealV2Data = this.getPriceRevealV2Data();

    const getPriceRevealWidgetState = () => {
      const maxSavingPriceNotPresent =
        productData?.potentialPromotions?.length &&
        productData?.potentialPromotions?.filter(item => item?.maxSavingPrice > 0);
      const priceRevealed = localStorage?.getItem('priceReveal_v2') || duringBBSSale;
      return `sale price ${priceRevealed ? '' : 'not'} revealed and sale price ${
        maxSavingPriceNotPresent?.length > 0 ? '' : 'not'
      } avaliable`;
    };

    
    const saleDiscount = priceRevealV2Data ? priceRevealV2Data.discountValue : 0;

    let colorVariantCount =0;
    productData?.baseOptions?.map((variant, i) => {
      if (variant?.variantType === 'FnlColorVariant') {  
        colorVariantCount++;     
      }
    })
  

    gtmPagePush('', 'product page', window.__ENV__ || '', {
      number_of_sizes_OOS: oosStatus.length,
      number_of_sizes: variantOptions?.length,
      number_of_coupons_shown: potentialPromotions?.length,
      Product_MRP: productMRP,
      product_selling_price: value,
      ...(isCopilotReferrer() && {
        plp_source_details: 'ai_assistant_widget'
      }),
      product_trade_discount: discountValue,
      standard_size_guide: newSizeRevampDesktopFlag,
      bbs_widget: this.isPriceRevealV2 ? 'Visible' : 'Not visible',
      bbs_widget_state: getPriceRevealWidgetState(),
      bbs_banner: this.isPriceRevealV2 ? 'Visible' : 'Not visible',
      pdp_td: discountValue,
      sale_discount: saleDiscount,
      sale_delta: saleDiscount ? saleDiscount - parseInt(discountValue, 10) : 0,
      store: currentStore,
      serviceName: 'pdp'
    },{
      ...productData?.potentialPromotions && productData?.potentialPromotions.length > 0 && {
        best_coupon_discount: productData?.potentialPromotions[0].maxSavingPrice,
        best_coupon_name: productData?.potentialPromotions[0].code,
      },
      number_of_ratings_collected: productData?.ratingsResponse?.aggregateRating?.averageRating,      
      number_of_color_variant_avialable: colorVariantCount

    });

    if (newDesignLuxe && oosStatus.includes(selectedSizeCode)) {
      this.luxeEventPush({
        event: 'cta_disabled',
        event_category: 'errors interactions',
        event_action: 'cta disabled',
        event_label: 'Item is Out of Stock',
        eventName: 'cta_disabled',
        isViewProductDetails: 'no'
      });
    }
    if (productData.fnlColorVariantData && productData.fnlColorVariantData.sizeGuideDesktop) {
      let sz = JSON.parse(productData.fnlColorVariantData.sizeGuideDesktop);
      let { sizeChart = [] } = sz;
      if (sizeChart.length > 0) {
        let { SIZEGUIDE_MEASUREMENT_UNIT = '' } = sizeChart[0];
        this.mUnit = SIZEGUIDE_MEASUREMENT_UNIT;
      }
      // this.props.fetchSizeData({
      //   'application':sz.applicationName?sz.applicationName:" ",
      //   'brick':sz.brickCode?sz.brickCode:" ",
      //   'brand':sz.brandCode?sz.brandCode:" ",
      //   'vendor':sz.vendorCode?sz.vendorCode:" ",
      //   'fit':sz.fittingType?sz.fittingType:" ",
      //   'style':sz.hasOwnProperty("style")?sz.style:" ",
      //   // 'style':this.props.productData.styleType ? this.props.productData.styleType :" ",
      //   productCode,
      //   seasonCode,
      //   gender,
      //   'subCategory': planningCategory.toLowerCase() === "clothing" ? "YES" : "NO",
      // });

      if (signInCheck().length > 0 && sizeRecommendFlag) {
        this.props.sizeRecommend(
          {
            application: sz.applicationName ? sz.applicationName : ' ',
            brick: sz.brickCode ? sz.brickCode : ' ',
            brand: sz.brandCode ? sz.brandCode : ' ',
            vendor: sz.vendorCode ? sz.vendorCode : ' ',
            fit: sz.fittingType ? sz.fittingType : ' ',
            style: sz.hasOwnProperty('style') ? sz.style : ' ',
            // 'style':this.props.productData.styleType ? this.props.productData.styleType :" ",
            productCode,
            seasonCode,
            gender,
            subCategory: planningCategory.toLowerCase() === 'clothing' ? 'YES' : 'NO',
            recommendDataVariant: getFeatureVariant('singleRecommend') || '0'
          },
          'desktop'
        );
      }
    }

    const {
      productData: { fnlColorVariantData: { sizeGuideDesktop = {} } = {} } = {}
    } = this.props;
    let sizeChartData = !isEmpty(sizeGuideDesktop) && JSON.parse(sizeGuideDesktop);
    !isEmpty(sizeGuideDesktop) && this.createSizeGuideData(sizeChartData);

    // Get Initial Deal of the day data
    const isDodData = !!_get(productData, 'price.deal');
    if (isDodData) {
      const { deal = {} } = productData.price;
      const {
        isDealEnabled = false,
        isSoldOut = false,
        dealType = '',
        dealPrice = '',
        dealPercentage = '',
        premiumDealStartTime = '',
        actualDealStartTime = '',
        dealEndTime = '',
        dealCode = ''
      } = deal;
      const { isDealStart = false } = IsDealStart(actualDealStartTime);
      const { isDealEnd = true } = dealEndTime && IsDealEnd(dealEndTime);
      if (isDealStart && !isDealEnd) {
        this.setState({
          initialDeal: { ...deal }
        });
      }
    }

    // check to show brand Size or standard Size and then set label
    newSizeRevampDesktopFlag && this.updateStaticData();

    this.handleLuxeGtmEvents();
    const dressToolButton = document.getElementById('dressToolBannerPDPDesktopButton');
    if (dressToolButton) {
      this.dressToolObserver = new IntersectionObserver(this.handleDressToolIntersection);
      this.dressToolObserver.observe(dressToolButton);
    }
  }
  handleDressToolIntersection = ([entry]) => {
    const {
      productData: {
        baseProduct: productCode = '',
        brickName,
        brickCategory,
        brandName,
        name: productName = ''
      } = {},
      dressToolPdpBannerConfig,
      ga4AjioEnable,
      newDesignLuxe
    } = this.props;

    const storeName = getStoreName();
    const { showBanner, imgUrl, visibilityConditions } = dressToolPdpBannerConfig || {};

    const dressToolVisibility =
      showBanner &&
      imgUrl?.length > 0 &&
      visibilityConditions?.[brickCategory]?.some(name => name.trim() === brickName);

    if (!entry.isIntersecting || newDesignLuxe || !dressToolVisibility || !ga4AjioEnable) {
      return;
    }

    gtmDatalayerPushData(
      {
        event: 'view_promotion',
        hybris_id: getUserUUID(),
        store_type: storeName,
        contains_store: storeName,
        product_id: productCode,
        product_name: productName,
        product_brand: brandName,
        product_brick: brickName,
        isGA4: true
      },
      'gtmPromotionCmsClick'
    );
    // to trigger above event only once
    this.dressToolObserver.unobserve(entry.target);
  };

  componentWillUnmount() {
    // Clean up the observer when the component unmounts
    if (this.dressToolObserver) {
      this.dressToolObserver.disconnect();
    }
  }
  handleLuxeGtmEvents = data => {
    const {
      productData: {
        baseProduct: productCode = '',
        brickCategory: productCategory,
        brickSubCategory: productSubCategory,
        brandName,
        brickName,
        fnlColorVariantData: { color: productColor = '', productTag = '', exclusiveTill = '' } = {},
        price: { value: finalPrice, discountPercent = '', segmentId = '', experimentId = '' } = {},
        wasPriceData: { value: price = '' } = {},
        name,
        tagResponse: { tag: { categoryTags = [] } = {} } = {},
        ratingsResponse,
        stock = {},
        code
      } = {},
      selectedSizeCode,
      newDesignLuxe,
      productCatalog,
      ga4AjioEnable,
      enableGiftWithProduct,
      giftWithProductConfig,
      freebiesItemsCount,
      isAjioSuperCashPdpEnabled,
      isBetterPdpEnabled,
      isSectionOneTabViewEnabled,
      isSectionTwoTabViewEnabled,
      isSectionThreeTabViewEnabled
    } = this.props;
    const totalInStockItems = (this.props?.productData.variantOptions ?? []).reduce((acc, el) => {
      acc = el?.stock?.stockLevel ?? 0;
      return acc;
    }, 0);
    const product_tag = exclusiveTill ? 'EXCLUSIVE' : productTag;
    const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
    const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
    const averageRating = ratingsResponse?.aggregateRating?.numUserRatings;
    const ratingCount = ratingsResponse?.aggregateRating?.averageRating;
    // const availableQuantityData = stock?.stockLevel > 0 ? stock?.stockLevel : 0;
    const isProductOOS = stock?.stockLevelStatus?.toLowerCase() === 'outofstock';
    const oosReason = stock?.stockErrorDescription ? `|${stock?.stockErrorDescription}` : '';
    let dimension59Data = `${isProductOOS ? 0 : totalInStockItems}|${
      isProductOOS ? 'non-deliverable' : 'deliverable'
    }${oosReason}`;
    let dimension166 =
      !newDesignLuxe && getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '';

    let freebiesText = `GetFreebies - ${freebiesItemsCount}`;

    if (enableGiftWithProduct && freebiesItemsCount > 0) {
      dimension166 = dimension166 ? `${dimension166}, ${freebiesText}` : `${freebiesText}`;
    }
    const { superCashEarning, earnRuleId } = this.getSizeSuperCashEarning();

    let validToken = getValidAttributionToken();

    console.log('TRACK DIMENSION 59 DATA ~ dimension59Data:', dimension59Data);
    let itmSourceDetail = null;
    if (isCopilotReferrer()) {
      itmSourceDetail = 'ai_assistant_widget';
    }
    if (newDesignLuxe) {
      luxeGtmProductDetailView(
        name,
        productCode?.split('_')[0],
        ga4AjioEnable ? finalPrice : price,
        brandName,
        productCategory,
        selectedSizeCode,
        productColor,
        discountPercent,
        brickName,
        getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : product_tag,
        getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
        'plp screen',
        'luxe',
        screenType,
        screenName,
        productCatalog,
        segmentId,
        experimentId,
        dimension59Data,
        price,
        dimension166,
        itmSourceDetail
      );
    } else {

      const { sectionOneData, sectionTwoData, sectionThreeData, betterPdpTitle } = this.props;
      const hasFeaturedData = data => data?.featureData?.length > 0;
      const showNewVariant = isBetterPdpEnabled
        ? hasFeaturedData(sectionOneData) ||
          hasFeaturedData(sectionTwoData) ||
          hasFeaturedData(sectionThreeData)
        : false;

      const betterPdpDetailsSections = [
        { name: 'sectionOne', data: sectionOneData, isTabView: isSectionOneTabViewEnabled },
        { name: 'sectionTwo', data: sectionTwoData, isTabView: isSectionTwoTabViewEnabled },
        { name: 'sectionThree', data: sectionThreeData, isTabView: isSectionThreeTabViewEnabled }
      ];

      gtmProductDetailView(
        name,
        selectedSizeCode || code?.split('_')[0],
        'Product Page',
        price,
        brandName,
        productCategory,
        productSubCategory,
        code?.split('_')[1],
        discountPercent,
        selectedSizeCode,
        getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : '',
        dimension166,
        averageRating,
        ratingCount,
        productCatalog,
        segmentId,
        experimentId,
        dimension59Data,
        finalPrice,
        isAjioSuperCashPdpEnabled ? earnRuleId : undefined,
        isAjioSuperCashPdpEnabled ? superCashEarning : undefined,
        validToken,
        itmSourceDetail,
        betterPdpDetailsSections,
        showNewVariant
      );
    }
  };

  componentDidUpdate(prevProps, prevState) {
    let { dodSize = {}, jioAddData } = this.props;
    const { code = '', priceData: { deal = {} } = {} } = dodSize;
    const isDodSizeSelected = !!_get(dodSize, 'priceData.deal');
    let isDodItemOutOfStock = isDodSizeSelected ? _get(dodSize, 'priceData.deal.isSoldOut') : false;
    const {
      isDealEnabled = false,
      isSoldOut = false,
      dealType = '',
      dealPrice = '',
      dealPercentage = '',
      premiumDealStartTime = '',
      actualDealStartTime = '',
      dealEndTime = '',
      dealCode = ''
    } = deal;

    const { isDealStart = false } = actualDealStartTime && IsDealStart(actualDealStartTime);
    const { isDealEnd = true } = dealEndTime && IsDealEnd(dealEndTime);
    if (isDealStart && !isDealEnd && this.dodCode !== code) {
      this.dodCode = code;
      if (isDodItemOutOfStock) {
        this.props.showModal('deal-out-of-stock');
        // dodTimerId && clearTimeout(dodTimerId);
      }
    }

    const { JioAds } = window;
    console.log('TRACK JIO ADS OBSERVATION POINT 4 : ~ JioAds:', JioAds);
    console.log(
      'TRACK JIO ADS OBSERVATION POINT 4 : ~ this.state.isJioAdsLoaded:',
      this.state.isJioAdsLoaded
    );
    console.log('TRACK JIO ADS OBSERVATION POINT 4 : AAAAAAAAAAAAAAAAAAAA', jioAddData);
    if (JioAds && this.state.isJioAdsLoaded) {
      console.log('TRACK JIO ADS OBSERVATION POINT 4 : BBBBBBBBBBBBBBBBBBBBB', jioAddData);
      jioAdsProductViewEvent(jioAddData);
      deeplinkLaunchEvent();
      this.setState({
        isJioAdsLoaded: false
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    //   const {
    //     productData: {
    //       fnlColorVariantData: {
    //         sizeGuideDesktop = {}
    //       } = {}
    //     } = {}
    //   } = nextProps.sizeData;
    //   console.log(sizeGuideDesktop)
    //   let sizeChartData = !isEmpty(sizeGuideDesktop) && JSON.parse(sizeGuideDesktop);
    //   console.log(nextProps.sizeData)
    // if(this.props && nextProps && this.props.sizeData!==nextProps.sizeData){
    //     this.createSizeGuideData(sizeChartData);
    //   }
  }

  createSizeGuideData = data => {
    // let data = this.props.sizeData;

    if (Object.keys(data).length > 0 && data.sizechart) {
      let { applicationName = '', brickCode = '' } = data;
      let {
        measurementType = '',
        brandName = '',
        brickName = '',
        brandLogo = '',
        brandCode = '',
        gender = '',
        tips = '',
        howToMeasureImage1Url = '',
        brickBrandSizes = [],
        measurementUnit = '',
        sizeGuideMeasurementUnit = ''
      } = data.sizechart[0];
      let dummyObj = {
        APPLICATION_NAME: applicationName,
        BRICK_CODE: brickCode,
        MEASUREMENT_TYPE: measurementType,
        BRAND_NAME: brandName.toUpperCase(),
        BRICK_NAME: brickName,
        BRAND_LOGO: brandLogo,
        BRAND_CODE: brandCode,
        GENDER: gender,
        TIPS: tips,
        Size_HEADER: 'Size',
        // SIZEGUIDE_MEASUREMENT_UNIT:this.mUnit,
        SIZEGUIDE_MEASUREMENT_UNIT: sizeGuideMeasurementUnit,
        MEASUREMENT_UNIT: measurementUnit,
        HOW_TO_MEASURE_IMAGEURL_1: howToMeasureImage1Url,
        STOCK_LEVEL: 0
      };

      if (sizeGuideMeasurementUnit === '0') {
        this.setState(prevState => {
          return {
            ...prevState,
            hideToggle: true,
            defaultUnit: true
          };
        });
      }
      if (sizeGuideMeasurementUnit === '') {
        this.setState(prevState => {
          return {
            ...prevState,
            inches: true,
            inchesIntConv: true,
            defaultUnit: true
          };
        });
      }
      if (sizeGuideMeasurementUnit === '1') {
        this.setState(prevState => {
          return {
            ...prevState,
            inches: false,
            inchesIntConv: false,
            defaultUnit: true
          };
        });
      }

      let x = brickBrandSizes;
      let fnlArr = [];
      x.forEach((arrayEL, index) => {
        let {
          sizeChartAttributes = [],
          sizeChartInternationalConversions = [],
          sizeChartBrandComparisions = []
        } = arrayEL;
        fnlArr[index] = {
          SIZE_NAME: arrayEL.sizeName,
          PRIORITY: arrayEL.sizePriority
        };
        if (sizeChartAttributes) {
          sizeChartAttributes.forEach((val, idx) => {
            if (val.attributeName.includes('_attribute') && val.attributeValue === '') {
              val = undefined;
            }
            let key = val?.attributeName;
            if (sizeGuideMeasurementUnit === '') {
              fnlArr[index] = {
                ...fnlArr[index],
                [key]: val?.attributeValue,
                [`_cm_${key}`]: val?.convertedAttributeValue
              };
            } else if (sizeGuideMeasurementUnit === '1') {
              fnlArr[index] = {
                ...fnlArr[index],
                [key]: val?.attributeValue,
                [`_inch_${key}`]: val?.convertedAttributeValue
              };
            } else {
              fnlArr[index] = {
                ...fnlArr[index],
                [key]: val?.attributeValue
              };
            }
          });
        }
        if (sizeChartInternationalConversions) {
          sizeChartInternationalConversions.forEach((val, idx) => {
            let key = val.attributeName;
            fnlArr[index] = {
              ...fnlArr[index],
              [key]: val.attributeValue
            };
          });
        }

        if (sizeChartBrandComparisions) {
          sizeChartBrandComparisions.forEach((val, idx) => {
            let key = `${val.attributeName}_brand`;
            fnlArr[index] = {
              ...fnlArr[index],
              [key]: val.attributeValue
            };
          });
        }
        Object.assign(fnlArr[index], dummyObj);
      });
      fnlArr.forEach((el, index) => {
        const objKeys = Object.keys(fnlArr[index]);
        let newObj = {};
        objKeys.map(key => {
          if (
            key === 'Universal Size_attribute' ||
            key === '_cm_Universal Size_attribute' ||
            key === 'Universal Size Format_attribute' ||
            key === '_cm_Universal Size Format_attribute' ||
            key === 'Brand Size_attribute' ||
            key === '_cm_Brand Size_attribute' ||
            key === 'Size_HEADER' ||
            key === 'SIZE_NAME' ||
            key === 'Brand Size Format_attribute' ||
            key === '_cm_Brand Size Format_attribute' ||
            key === '_inch_Brand Size_attribute' ||
            key === '_inch_Universal Size_attribute' ||
            key === '_inch_Universal Size Format_attribute' ||
            key === '_inch_Brand Size Format_attribute'
          ) {
            newObj = { [key]: el[key], ...newObj };
          }
        });
        fnlArr[index] = { ...newObj, ...fnlArr[index] };
      });
      this.sizeGuide = fnlArr;
    }
  };

  fetchStockList = stocks => {
    this.setState({
      stockList: stocks
    });
  };

  handleGST = priceData => {
    const {
      taxInformation: { priceWithTaxes: { displayformattedValue = '', value = 0 } = {} } = {}
    } = priceData;
    let gstPrice = '';

    if (value > 0) {
      gstPrice = `${displayformattedValue} including GST`;
    } else {
      gstPrice = 'Additional GST may apply';
    }

    this.setState(prevState => {
      return {
        ...prevState,
        gstPrice
      };
    });
  };

  onActionClick = e => {
    let ensamble = document.getElementById('brandDetails');
    if (ensamble?.offsetTop) {
      let ensambleOffsetTop = ensamble.offsetTop - 150;
      let element = document.body;
      let duration = 500;
      if (duration <= 0) return;
      var difference = ensambleOffsetTop - element.scrollTop;
      var perTick = (difference / duration) * 10;

      setTimeout(function() {
        element.scrollTop += perTick;
        if (element.scrollTop === ensambleOffsetTop) return;
        scrollTo(element, ensambleOffsetTop, duration - 10);
      }, 10);
    }
  };

  handlePriceCartToPDP = (optionsParam, currentProductCodeParam) => {
    if (optionsParam.length) {
      for (let item of optionsParam) {
        const { code = '', priceData = {} } = item;
        if (code === currentProductCodeParam) {
          const {
            priceData: { displayformattedValue = '' } = {},
            wasPriceData: { displayformattedValue: wasDisplayFormattedValue = '' } = {}
          } = item;
          let {
            taxInformation: {
              priceWithTaxes: { displayformattedValue: gstCartToPDP = '', value = '' } = {}
            } = {}
          } = priceData;
          gstCartToPDP = value ? `${gstCartToPDP} including GST` : 'Additional GST may apply';
          return [displayformattedValue, wasDisplayFormattedValue, gstCartToPDP];
        }
      }
    }
    return [];
  };

  _handleDealStockOverOnSizeClick = () => {
    this.setState({
      showClaim: false
    });
  };

  _isDodStockOver = () => {
    let { dodSize = {} } = this.props;
    const { code = '' } = dodSize;

    this.setState({
      showClaim: true
    });
  };

  updateNewSize = sizeFormat => {
    const { sizeType = '', sizeTypeLabel = '' } = this.newSize;
    const { newSizeRevampDesktopFlag = true, productData = {}, dodSize = {} } = this.props;
    let displayBrandStandardSize = null;

    // if brand feature is enable then save size format + create size label node
    const showBrandSize = _get(dodSize, 'showBrandTextValue', '');
    const standardValue = _get(dodSize, 'value', '');
    sizeFormat = this.newSizeFormat;
    if (newSizeRevampDesktopFlag && sizeType === 'STANDARD') {
      if (showBrandSize) {
        if (this.showBrandFormat !== sizeFormat) {
          displayBrandStandardSize = (
            <div className="brandLabel">
              {`${sizeTypeLabel}`}&nbsp;<span>{` ${this.showBrandFormat} ${showBrandSize}`}</span>
            </div>
          );
        } else if (showBrandSize !== standardValue) {
          displayBrandStandardSize = (
            <div className="brandLabel">
              {`${sizeTypeLabel}`}&nbsp;<span>{` ${this.showBrandFormat} ${showBrandSize}`}</span>
            </div>
          );
        }
      }
    }
    return {
      displayBrandStandardSize,
      sizeFormat
    };
  };

  getPriceRevealDom = (price, discount, promotions) => {
    const { bbsPriceStaticText, bannerImgSrc } = this.props.priceRevealV2WebData;
    return (
      <div className="price-reveal-price-section prod-price-section">
        <div className="img-container">
          <img
            src={replaceWithJioCDN(bannerImgSrc?.image)}
            alt={bannerImgSrc?.altText || 'bbs-logo'}
          />
        </div>
        <div className="info">
          <div className="title ellipsis">{bbsPriceStaticText}</div>
          <div className="price-info ellipsis">
            {price}
            {discount ? <span className="discount">{`(${discount})`}</span> : null}
          </div>
        </div>
      </div>
    );
  };

  luxeEventPush = ({ eventName, color, ...rest }) => {
    const {
      selectedSizeCode,
      selectedSizeName,
      discountPercentage,
      productData: {
        brickSubCategory,
        brickName,
        name: productName,
        code: productCode,
        fnlColorVariantData: { color: productColor, brandName, productTag },
        price: { value: productPrice },
        wasPriceData: { value: originalPrice = 0, formattedValue: formattedMp = '' } = {}
      },
      productData = {},
      ga4AjioEnable
    } = this.props;
      console.log("🚀 ~ Description ~ productData:", productData)

    let eventPushObj = {
      product_details: {
        product_name: productName,
        product_id: selectedSizeCode || productCode,
        product_brand: brandName,
        product_price: productPrice,
        product_color: color || productColor,
        product_size: selectedSizeName,
        product_trade_discount: discountPercentage,
        product_catogory: brickSubCategory,
        product_brick: brickName,
        product_tag: productTag
      },
      user_details: {
        store_type: 'luxe',
        user_status: signInCheck() ? 'logged in' : 'not logged In',
        time_of_the_day: '',
        login_type: signInCheck() ? 'logged in' : 'not logged In',
        screen_name: screenName,
        screen_type: screenType
      }
    };
    let pushDataObj =
      rest.isViewProductDetails && rest.isViewProductDetails === 'no'
        ? { ...eventPushObj.user_details }
        : { ...eventPushObj.user_details, ...eventPushObj.product_details };
    delete rest.isViewProductDetails;
    if (ga4AjioEnable) {
      gtmEventPush({
        event: 'add_to_wishlist',
        isGA4: true,
        ecommerce: {
          currency: 'INR',
          value: Number(productPrice) || 0,
          items: [
            {
              item_id: selectedSizeCode || productCode,
              item_name: productName,
              discount: originalPrice ? Number(originalPrice - productPrice) || 0 : 0,
              index: 0,
              item_brand: brandName,
              item_category: brickSubCategory,
              item_list_name: 'Product',
              item_variant: color || productColor,
              price: productPrice,
              quantity: 1,
              ...eventPushObj.product_details
            }
          ]
        },
        ...eventPushObj.user_details
      });

      // Send segment
      // commented this event, as facing issue "productData is not defined"
      // segmentEventPush({
      //   event: 'Product Wishlisted',
      //   //isGA4: true,
      //   wishlisted_source: 'Save to Wishlist',
      //   ecommerce: {
      //     //currency: 'INR',
      //     //value: Number(productPrice) || 0,
      //     items: [
      //        {
      //         ...getProductItemPDP(productData)
      //       }
      //     ]
      //   },
      //   //...eventPushObj.user_details
      // });
    } else {
      gtmEventPush({
        event: eventName,
        event_category: 'product details interactions',
        ...pushDataObj,
        ...rest
      });
    }
  };

  getSectionalData = (sectionData, max_val = 20) => {
    return (
      sectionData?.featureData
        ?.map(list => ({
          key: list?.name,
          title: list?.featureValues[0]?.value
        }))
        .slice(0, max_val) || []
    );
  };

  // Function to render formatted data
  renderFormatData = (featuredData, isTabView, truncate) => {
    const { maxLineForValue } = this.props;
    return featuredData?.map((list, index) => (
      <div 
        className={isTabView ? 'pdpTabSub' : 'pdpNormalSub'} 
        key={index} 
        aria-label={`${list?.key} : ${list?.title}`}
        role="presentation"
      >
        <div className={isTabView ? 'tabName' : 'NormalViewName'} aria-hidden="true">{list?.key}</div>
        <div
          className={`detail-list ${index === featuredData?.length - 1 ? 'no-bottom-line' : ''} ${
            truncate ? 'truncate' : ''
          }`}
          style={{ WebkitLineClamp: maxLineForValue }}
          aria-hidden="true"
        >
          {list?.title}
        </div>
      </div>
    ));
  };

  getPdpDefaultSections = sections => {
    const MAX_LINES = 4;
    let totalLinesUsed = 0;
    const defaultBody = [];
    let normalViewUtilised = false;
    const { maxKeyValuePair } = this.props;

    sections.forEach(section => {
      if (section && section.data) {
        const { data = {}, isTabView } = section;

        const linesToUse = Math.floor(MAX_LINES - totalLinesUsed);

        if (linesToUse > 0) {
          const maxItemsToShow = isTabView
            ? Math.min(linesToUse * 2, data?.featureData?.length || 0)
            : Math.min(1, data?.featureData?.length || 0);

          const maxItems = maxKeyValuePair < maxItemsToShow ? maxKeyValuePair : maxItemsToShow;
          const sectionalData = this.getSectionalData(data, maxItems);
          totalLinesUsed += isTabView ? Math.ceil(maxItems / 2) : 1;
          // Render the section only if we haven't utilized the normal view yet or if it's a tab view
          if (totalLinesUsed <= MAX_LINES) {
            if (!isTabView && !normalViewUtilised) {
              defaultBody.push(
                <div className="pdpNormalContainer truncate no-bottom-line" key={section?.name}>
                  {this.renderFormatData(sectionalData, false, true)}
                </div>
              );
              normalViewUtilised = true;
            } else if (isTabView) {
              defaultBody.push(
                <div className="pdpTabContainer" key={section?.name} role="presentation">
                  {this.renderFormatData(sectionalData, true)}
                </div>
              );
            }
          }
        }
      }
    });
    return <>{defaultBody}</>;
  };

  getPdpAllSections = sections => {
    const { maxKeyValuePair } = this.props;
    return (
      <>
        {sections?.map((section, index) => {
          const { isTabView } = section;
          const containerClass = isTabView ? 'pdpTabContainer' : 'pdpNormalContainer';
          if (section?.data?.featureData?.length > 0) {
            return (
              <div className={containerClass} key={section.name}>
                {this.renderFormatData(
                  this.getSectionalData(section?.data, maxKeyValuePair),
                  isTabView
                )}
              </div>
            );
          }
        })}
      </>
    );
  };

  renderOldDesign = (productData = {}) => {
    if (productData?.featureData) {
      return productData?.featureData.map((list, i) => {
        if (
          list.name !== 'Pantone Shade' &&
          list.name !== 'Size worn by Model' &&
          list.name !== 'Model Chest Size' &&
          list.name !== 'Model Waist Size' &&
          list.name !== 'Model Height' &&
          list.name !== 'Size Format'
        ) {
          return list?.featureValues?.map((sublist, j) => {
            const { value = '' } = sublist;
            return (
              value &&
              value !== 'UNI' && (
                <li className={list.name === 'USP' ? 'pdp-li-desc' : 'detail-list'} key={j}>
                  {value.slice(-1) !== '.' && list.name === 'USP' ? `${value}.` : value}
                </li>
              )
            );
          });
        }
      });
    }
    return '';
  };

  getSizeSuperCashEarning = () => {
    const { productData, selectedSizeCode } = this.props;

    let { price: { priceReveal } = {}, variantOptions, baseOptions = [], code: prodCode = '' } =
      productData || {};

    const defaultSelectedSize = baseOptions.filter(variant => {
      const { selected: { code } = {} } = variant || {};

      return prodCode === code;
    });

    let superCashEarning;
    let earnRuleId;

    if (defaultSelectedSize && defaultSelectedSize.length > 0 && selectedSizeCode.length === 0) {
      const {
        selected: { priceData: { superCashEarning: scEarning, earnRuleId: erId } = {} } = {}
      } = defaultSelectedSize[0] || {};
      superCashEarning = scEarning;
      earnRuleId = erId;
    } else if (selectedSizeCode && selectedSizeCode.length > 0) {
      const variantProductData = variantOptions.filter(item => item.code === selectedSizeCode);

      const selectedProductData = variantProductData && variantProductData.length ? variantProductData[0] : {};
      const {
        priceData: { superCashEarning: scEarning, earnRuleId: erId } = {}
      } = selectedProductData;
      superCashEarning = scEarning;
      earnRuleId = erId;
    }
    return { superCashEarning, earnRuleId };
  };

  handleDressToolClick = () => {
    const { showModal, initiateInitialFlag, ga4AjioEnable } = this.props;

    showModal('dress-tool-modal');
    initiateInitialFlag();

    if (ga4AjioEnable) {
      gtmDatalayerPushData(
        {
          event: 'select_promotion',
          hybris_id: getUserUUID(),
          store_type: getStoreName(),
          contains_store: getStoreName(),
          product_id: this.props.productCode,
          product_name: this.props.productName,
          product_brand: this.props.brandName,
          product_brick: this.props.brickName,
          isGA4: true
        },
        'gtmPromotionCmsClick'
      );
      segmentEventPush({
        event:'Banner Clicked',
        ad_budget: '',
        ad_cost:'',
        ad_flag:'',
        ad_id:'',
        ad_type:'',
        properties: {
          Banners: [
            {
              banner_id: (dressToolPdpBannerConfig && dressToolPdpBannerConfig?.bannerName ? dressToolPdpBannerConfig?.bannerName : 'pdp'),
              banner_name : (dressToolPdpBannerConfig && dressToolPdpBannerConfig?.bannerName ? dressToolPdpBannerConfig?.bannerName : 'pdp'),
              banner_position : '',
              banner_type : 'IMAGE',
              clickable : true,
            }
          ]
        },
        screen_name: 'PDP screen'
      });
    }

    sessionStorage.setItem(
      'dressToolIngressDetails',
      JSON.stringify({
        IngressPoint: 'pdp',
        BannerName: this.props.dressToolPdpBannerConfig?.bannerName || 'pdp'
      })
    );
  };

  handleDressToolKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setTimeout(this.handleDressToolClick, 0);
    }
  };

  render() {
    // {this.props.sizeData?this.createSizeGuideData():null}
    const {
      productData = {},
      oosStatus,
      selectedSizeCode,
      dodSize = {},
      showBrandSizeDesktopFlag = false,
      newSizeRevampDesktopFlag = false,
      selectedSizeName,
      trustMarkerTxt,
      earlyAccessFlag,
      earlyAccessData,
      currentStore,
      enableRating,
      showPDPRateSection,
      storesForHidingMRP,
      freebiesItemsList,
      freebiesItemsCount,
      isComingSoonEnabled,
      dressToolPdpBannerConfig,
      ga4AjioEnable,
      isBetterPdpEnabled,
      isSectionOneTabViewEnabled,
      isSectionTwoTabViewEnabled,
      isSectionThreeTabViewEnabled,
      isAjioSuperCashPdpEnabled,
      ajioSuperCashConfig,
      emiDiscountEnable,
      emiDetails,
      emiThresholdAmount,
      emiTemplate,
      openViewMoreEmiModal,
      serviceabilityDetails = {}
    } = this.props;
    const { showEmi = false } = serviceabilityDetails;
    let { tagResponse: { tag: { categoryTags = [] } = {} } = {}, brickSubCategory } = productData;
    let { mandatoryInfo = [], saleStartTime, saleEndTime } = productData;
    let { fnlColorVariantData = {}, images = [] } = productData;
    const { productCode = '', productName = '' } = productData;
    let { catalog } = productData;
    let { brandName = '' } = fnlColorVariantData;
    let brandNameValue = productData.fnlColorVariantData.brandName;
    let brandNameUpperCase = brandNameValue.toUpperCase();
    const { featuredPlan = {} , offers = [] } = emiDetails;

    let promotionalData = productData.potentialPromotions;

    if(emiDiscountEnable && showEmi) {
      promotionalData = [...promotionalData, ...offers];
      console.log("promotionalData", promotionalData)
    }

    let sizeToolTip;
    let sizeGuide = {};
    let modelData = [];
    let strikePrice = '';
    let discountPercent = '';
    let stockLevelStatus = 'outOfStock';

    // NOTE: FOR SIZE RECOMMENDATION
    const { sizeRecommendFetch } = this.props;

    const { superCashEarning } = this.getSizeSuperCashEarning();
    const superCashTemplateConfig = ajioSuperCashConfig?.pdpPageConfig?.pdpSuperCashTitle;
    const superCashEarningTemplate = (superCashTemplateConfig || '').replace( /\{super_cash\}/g, Number(superCashEarning)?.toFixed(2) || '');
  
    if (productData.featureData) {
      modelData = productData.featureData;
    }
    // if(productData.fnlColorVariantData && productData.fnlColorVariantData.sizeGuideDesktop){
    //   sizeGuide = JSON.parse(productData.fnlColorVariantData.sizeGuideDesktop);
    // }
    // const { sizeGuideDesktop='' } = productData.fnlColorVariantData;
    // const { sizeChart='' } = sizeGuide;

    let sizeChart = this.sizeGuide;
    if (productData.fnlColorVariantData && productData.fnlColorVariantData.sizeToolTip) {
      sizeToolTip = JSON.parse(productData.fnlColorVariantData.sizeToolTip);
    }
    let colorVariant;
    let sizeVariant;
    let sizeFormat;
    let currentProductCode = '';
    let displayBrandStandardSize;
    // From Cart to PDP Page
    let priceCartToPDP = '';
    let wasPriceCartToPdp = '';
    let gstCartToPDP = '';
    const { cartOrNot = false } = this.props;
    productData.baseOptions.map((variant, i) => {
      if (variant.variantType === 'FnlColorVariant') {
        colorVariant = variant;
      } else if (variant.variantType === 'FnlSizeVariant') {
        sizeVariant = variant.options;
        currentProductCode = variant.selected.code;
        const { selected: { variantOptionQualifiers = [] } = {}, options = [] } = variant;
        for (const size of variantOptionQualifiers) {
          if (size.qualifier === 'size') {
            sizeFormat = size.value;
          }
          if (size.qualifier === 'standardSize' && size.value) {
            sizeFormat = size.value;
            flag = true;
          }
        }
        if (!cartOrNot) {
          [
            priceCartToPDP = '',
            wasPriceCartToPdp = '',
            gstCartToPDP = ''
          ] = this.handlePriceCartToPDP(options, currentProductCode);
        }
      }
    });

    if (sizeVariant === undefined) {
      sizeVariant = productData.variantOptions;
    }
    let selectedColor = colorVariant.selected.code;
    if (colorVariant && colorVariant.options.length) {
      colorVariant.options.forEach((color, i) => {
        if (color.stock && color.stock.stockLevelStatus !== 'outOfStock') {
          let { wasPriceData = {}, priceData = {} } = color;
          if (color.code === selectedColor) {
            strikePrice = wasPriceData.displayformattedValue;
            let sp = priceData.value;
            let cp = wasPriceData.value;
            let discount;
            if (sp !== cp) {
              discount = Math.round(((cp - sp) / cp) * 100);
              discountPercent = `${discount}% off`;
            }
          }
        }
      });
    }
    // else{
    discountPercent = !discountPercent ? productData.discountPercent : discountPercent;
    if (productData.wasPriceData) {
      strikePrice = productData.wasPriceData.displayformattedValue;
    }
    // }
    {
      productData.featureData &&
        productData.featureData.map((list, i) => {
          if (
            (list.name === 'Size Format' || list.name === 'sizeFormat') &&
            list.featureValues[0].value !== 'UNI' &&
            !sizeFormat
          ) {
            sizeFormat = list.featureValues[0].value || sizeFormat;
            if (this.newSize.sizeType === 'STANDARD') {
              this.showBrandFormat = list.featureValues[0].value;
            }
          }
        });
    }
    const { price = {} } = productData;
    let {
      displayformattedValue: sellingPrice = '',
      taxInformation: { priceWithTaxes: { displayformattedValue = '', value = '' } = {} } = {}
    } = price;

    const boolGST = value > 0 && displayformattedValue.length;
    displayformattedValue += ' including GST';

    if (this.state.gstPrice.length) {
      displayformattedValue = this.state.gstPrice;
    }

    const filterByStock = size => {
      if (size.stock && size.stock.stockLevelStatus !== 'outOfStock') {
        stockLevelStatus = size.stock.stockLevelStatus;
      }
    };
    let filterData = sizeVariant.filter(filterByStock);
    let sizeCode = sizeVariant[0].code;
    let discountPercentage = this.props.discountPercentage
      ? this.props.discountPercentage
      : productData.discountPercent;
    sellingPrice = priceCartToPDP || sellingPrice;
    strikePrice = wasPriceCartToPdp || strikePrice;
    displayformattedValue = gstCartToPDP || displayformattedValue;
    const { discountPrice = '' } = this.props;
    const finalPriceAfterDiscount = priceCartToPDP || discountPrice;

    // Deal of the Day
    // Get Initial DOD data
    let {
      isDealEnabled = false,
      isSoldOut = false,
      dealType = '',
      dealPrice = '',
      dealPercentage = '',
      premiumDealStartTime = '',
      actualDealStartTime = '',
      dealEndTime = '',
      dealCode = ''
    } = this.state.initialDeal;
    let dodWasPrice = '';
    let dodStockNumber = '';
    let dodOriginalPrice;
    let dodStockStatus = '';
    let isDodItemOutOfStock = false;

    const { isDealStart = false } = actualDealStartTime && IsDealStart(actualDealStartTime);
    const { isDealEnd = true } = dealEndTime && IsDealEnd(dealEndTime);
    const isDodSizeSelected = !!_get(dodSize, 'priceData.deal');
    if (isDodSizeSelected) {
      isDealEnabled = _get(dodSize, 'priceData.deal.isDealEnabled') || false;
      dealPrice = _get(dodSize, 'priceData.deal.dealPrice') || '';
      dealPercentage = _get(dodSize, 'priceData.deal.dealPercentage') || '';
      dealEndTime = _get(dodSize, 'priceData.deal.dealEndTime') || '';
      dodOriginalPrice = _get(dodSize, 'priceData.value') || '';
      dodWasPrice = _get(dodSize, 'wasPriceData.value') || '';
      dodStockStatus = _get(dodSize, 'stockLevelStatus') || '';
      isDodItemOutOfStock = _get(dodSize, 'priceData.deal.isSoldOut') || '';

      if (dodStockStatus === 'inStock') {
        dodStockNumber = _get(dodSize, 'stockLevel') || '';
      }
      if (dodOriginalPrice === dodWasPrice) {
        dodWasPrice = '';
      }
    }

    const dodPriceSectionClass = isDealStart && !isDealEnd ? 'dod-price-section' : '';
    const priceSectionDom =
      isDealStart && !isDealEnd && !this.state.showClaim ? (
        <div className="dealSection">
          <div className="dealSection__price">
            Deal Price: <span>{`₹${dealPrice}`}</span>
          </div>
          <DealOfTheDayTimerTag
            dealOfTheDayProductTimer={dealEndTime}
            imagePath="/static/img/endsIn.png"
            alt="Timer icon"
          />
        </div>
      ) : null;

    const oldPriceList =
      isDealStart && !isDealEnd && !this.state.showClaim ? (
        <div className="cutPrice">
          <span />
          <span className="originalCutPrice"> {finalPriceAfterDiscount || sellingPrice}</span>
          <span className="wasCutPrice">
            {strikePrice && sellingPrice !== strikePrice
              ? strikePrice
              : this.props.originalPrice !== this.props.discountPrice
              ? this.props.originalPrice
              : ''}
          </span>
          {parseInt(discountPercent) > 0 && (
            <span className="dealPriceDiscount">
              &nbsp;({discountPercentage || discountPercent})
            </span>
          )}
        </div>
      ) : null;

    const dealClaim =
      this.state.showClaim && isDodItemOutOfStock ? (
        <div className="dealClaim">
          <div className="dealClaim__message">100% Deal Claimed</div>
          <div className="dealClaim__price">
            Deal Price: <span>{displayValueWithSymbol(dealPrice)}</span>
          </div>
        </div>
      ) : null;

    const {
      hideSizes,
      appendDesc,
      metalPurity,
      qualifierKey,
      selectedMetalName,
      qualifierKeysForDesc
    } = getVolumeAndSizeFlag(colorVariant);

    const trustmarkerImages = (images ? images.filter(filterTrustmarkerImage) : []).slice(0, 3);
    // create size node + add size format for New size feature
    ({ displayBrandStandardSize = null, sizeFormat = sizeFormat } =
      newSizeRevampDesktopFlag && this.updateNewSize(sizeFormat));

    // const priceRevealData = this.getPriceRevealData();
    const priceRevealV2Data = this.getPriceRevealV2Data();
    const showPriceRevealOnPromotions = this.showPriceRevealOnPromotions();
    const isPreBuzz = this.isPriceRevealV2 && this.showPriceRevealPreBuzz();
    const isDuringSale =
      this.isPriceRevealV2 && getSaleDuration(saleStartTime, saleEndTime) === DURING_SALE;
    const isPreSale =
      this.isPriceRevealV2 && getSaleDuration(saleStartTime, saleEndTime) === PRE_BUZZ;
    const maxSavingPriceNotPresent =
      productData?.potentialPromotions?.length &&
      productData?.potentialPromotions?.filter(item => item?.maxSavingPrice > 0);
    const newDesignLuxe = this.props.newDesignLuxe;
    const isEarlyAccessUser =
      isSignedIn && earlyAccessFlag && checkEarlyAccessUser(currentStore, 'pdp') && isPreSale;

    const { ratingsColor = {} } = this.props;
    const {
      thresholdValue = 3,
      ratingBelowThresholdColor = '',
      ratingAboveThresholdColor = ''
    } = ratingsColor;

    const radioProps = {
      size: 'sm',
      id: 4,
      totalStarCount: productData?.ratingsResponse?.aggregateRating?.numUserRatings,
      totalRatingCount: productData?.ratingsResponse?.aggregateRating?.averageRating,
      RatingCountBgColor:
        productData?.ratingsResponse?.aggregateRating?.averageRating < thresholdValue
          ? ratingBelowThresholdColor
          : ratingAboveThresholdColor,
      StarCountBgColor: '#ffffff',
      rateDesign: '',
      rateCustomCss: {
        color: '#6D6D6D',
        lineHeight: '1.2',
        letterSpacing: '0.28px',
        fontSize: '14px',
        margin: '0.3em 0 0.3em 0.5em'
      },
      productName: productData?.name,
      productId: productData?.code,
      brickCode: productData?.brickCode,
      sourcePage: 'PDP'
    };
    const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalog);
    const imageBaseUrl = properties.getProperty('imageBaseUrl');
    const starUrl = `${imageBaseUrl}/static/img/green_star_pdp.svg`;
    const totalStarCount = productData?.ratingsResponse?.aggregateRating?.numUserRatings;
    const totalRatingCount = productData?.ratingsResponse?.aggregateRating?.averageRating;
    const { isComingSoonProduct } = this.props.productData;

    const { brickCategory, brickName } = this.props.productData || {};
    const dressToolVisibility =
      dressToolPdpBannerConfig?.showBanner &&
      dressToolPdpBannerConfig?.imgUrl &&
      dressToolPdpBannerConfig?.imgUrl?.length > 0 &&
      dressToolPdpBannerConfig?.visibilityConditions[brickCategory]
        ?.map(name => name.trim())
        .includes(brickName);
    const { sectionOneData, sectionTwoData, sectionThreeData, betterPdpTitle } = this.props;

    const hasFeaturedData = data => data?.featureData?.length > 0;

    const showNewVariant = isBetterPdpEnabled
      ? hasFeaturedData(sectionOneData) ||
        hasFeaturedData(sectionTwoData) ||
        hasFeaturedData(sectionThreeData)
      : false;

    const betterPdpDetailsSections = [
      { name: 'sectionOne', data: sectionOneData, isTabView: isSectionOneTabViewEnabled },
      { name: 'sectionTwo', data: sectionTwoData, isTabView: isSectionTwoTabViewEnabled },
      { name: 'sectionThree', data: sectionThreeData, isTabView: isSectionThreeTabViewEnabled }
    ];

    const defaultRendered = this.getPdpDefaultSections(betterPdpDetailsSections);
    const allSectionsRendered = this.getPdpAllSections(betterPdpDetailsSections);
    return (
      <div className={`${newDesignLuxe ? 'luxe-newdesign' : ''}  prod-content`}>
        <h2 className="brand-name" aria-label={brandNameUpperCase}>
          {brandNameUpperCase}
        </h2>
        <h1 className="prod-name" aria-label={productData.name}>
          {productData.name}
          {metalPurity && selectedMetalName ? ` | ${selectedMetalName}` : ''}
          {selectedSizeName && selectedSizeName !== ' ' ? ` | ${selectedSizeName}` : ''}
        </h1>
        {enableRating && showPDPRateSection && (
          <>
            {productData?.ratingsResponse?.aggregateRating && (
              <div className="rating-popup">
                <RatingLabel {...radioProps} />
              </div>
            )}
          </>
        )}
        {isEarlyAccessUser && !productData?.potentialPromotions?.length ? (
          <></>
        ) : this.props.originalPrice && this.props.discountPrice ? (
          <>
            <div className={`prod-price-section ${dodPriceSectionClass}`}>
              {!isDealStart && isDealEnd ? (
                !productData.potentialPromotions ? (
                  <span className="prod-sp best-price-strip">
                    {displayValueWithSymbol(this.props.discountPrice)}
                  </span>
                ) : (
                  <div className="prod-sp">
                    {this.props.originalPrice === this.props.discountPrice && hideMRP && (
                      <span className="prod-mrp" aria-label={SHOW_MRP_TEXT}>
                        {SHOW_MRP_TEXT}
                      </span>
                    )}
                    {displayValueWithSymbol(finalPriceAfterDiscount)}
                  </div>
                )
              ) : isDealStart && !isDealEnd && this.state.showClaim ? (
                !productData.potentialPromotions ? (
                  <span className="prod-sp best-price-strip">{this.props.discountPrice}</span>
                ) : (
                  <div className="prod-sp">{displayValueWithSymbol(finalPriceAfterDiscount)}</div>
                )
              ) : null}
              {!isDealStart &&
              isDealEnd &&
              this.props.originalPrice !== this.props.discountPrice &&
              hideMRP ? (
                <div className="prod-price-sec">
                  <span className="prod-mrp" aria-label={SHOW_MRP_TEXT}>
                    {SHOW_MRP_TEXT}
                  </span>
                  <span className="prod-cp">
                    {displayValueWithSymbol(this.props.originalPrice)}
                  </span>
                  {parseInt(this.props.discountPercentage) > 0 && (
                    <span className="prod-discnt">&nbsp;({this.props.discountPercentage})</span>
                  )}
                </div>
              ) : isDealStart &&
                !isDealEnd &&
                this.state.showClaim &&
                this.props.originalPrice !== this.props.discountPrice &&
                hideMRP ? (
                <div className="prod-price-sec">
                  <span className="prod-mrp" aria-label={SHOW_MRP_TEXT}>
                    {SHOW_MRP_TEXT}
                  </span>
                  <span className="prod-cp">
                    {displayValueWithSymbol(this.props.originalPrice)}
                  </span>
                  {parseInt(this.props.discountPercentage) > 0 && (
                    <span className="prod-discnt">&nbsp;({this.props.discountPercentage})</span>
                  )}
                </div>
              ) : null}
              {oldPriceList}
              {priceSectionDom}
            </div>
            {emiDiscountEnable && showEmi && (
              <div
                className={newDesignLuxe ? 'luxe-no-cost-emi-container' : 'no-cost-emi-container'}
              >
                <div className="no-cost-emi-text">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: renderEMITemplate(
                        {
                          totalMonthlyAmountPayable: featuredPlan?.totalMonthlyAmountPayable,
                          tenure: featuredPlan?.tenure,
                          type: featuredPlan?.type,
                          thresholdAmount: emiThresholdAmount,
                          issuerSlug: featuredPlan?.issuerSlug,
                          cashbackApplied: featuredPlan?.cashbackApplied,
                          instantDiscountApplied: featuredPlan?.instantDiscountApplied,
                          bankInterestRate: featuredPlan?.bankInterestRate
                        },
                        emiDetails?.featuredPlan?.templateCode,
                        emiTemplate
                      )
                    }}
                  />
                </div>
               {emiDetails?.featuredPlan?.templateCode != 'GLOBAL_THRESHOLD' && <div className="view-more-plans" onClick={() => openViewMoreEmiModal(true)}>
                  View Plans
                </div>}
              </div>
            )}
            {newDesignLuxe ? (
              <div className="tax-text" aria-label="Price inclusive of all taxes">
                Price inclusive of all taxes
              </div>
            ) : (
              ''
            )}
          </>
        ) : isDuringSale && maxSavingPriceNotPresent?.length === 0 ? (
          this.getPriceRevealDom(sellingPrice, discountPercent)
        ) : (
          <>
            <div className={`prod-price-section ${dodPriceSectionClass}`}>
              {!isDealStart && isDealEnd ? (
                !productData.potentialPromotions ? (
                  <span className="prod-sp best-price-strip">
                    {displayValueWithSymbol(sellingPrice)}
                  </span>
                ) : (
                  <div className="prod-sp">
                    {strikePrice && sellingPrice === strikePrice && hideMRP && (
                      <span className="prod-mrp" aria-label={SHOW_MRP_TEXT}>
                        {SHOW_MRP_TEXT}
                      </span>
                    )}
                    {displayValueWithSymbol(sellingPrice)}
                  </div>
                )
              ) : (
                ''
              )}
              {strikePrice && sellingPrice !== strikePrice && !isDealStart && isDealEnd && hideMRP && (
                <div className="prod-price-sec">
                  <span className="prod-mrp" aria-label={SHOW_MRP_TEXT}>
                    {SHOW_MRP_TEXT}
                  </span>
                  <span className="prod-cp">{displayValueWithSymbol(strikePrice)}</span>
                  {parseInt(discountPercent) > 0 && !isDealStart && isDealEnd && (
                    <span className="prod-discnt">
                      &nbsp;({discountPercentage || discountPercent})
                    </span>
                  )}
                </div>
              )}
              {oldPriceList}
              {priceSectionDom}
            </div>
            {emiDiscountEnable && showEmi && (
              <div
                className={newDesignLuxe ? 'luxe-no-cost-emi-container' : 'no-cost-emi-container'}
              >
                <div className="no-cost-emi-text">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: renderEMITemplate(
                        {
                          totalMonthlyAmountPayable:
                            emiDetails?.featuredPlan?.totalMonthlyAmountPayable,
                          tenure: emiDetails?.featuredPlan?.tenure,
                          type: emiDetails?.featuredPlan?.type,
                          thresholdAmount: emiThresholdAmount,
                          issuerSlug: emiDetails?.featuredPlan?.issuerSlug,
                          cashbackApplied: emiDetails?.featuredPlan?.cashbackApplied,
                          instantDiscountApplied: emiDetails?.featuredPlan?.instantDiscountApplied,
                          bankInterestRate: emiDetails?.featuredPlan?.bankInterestRate
                        },
                        emiDetails?.featuredPlan?.templateCode,
                        emiTemplate
                      )
                    }}
                  />
                </div>
               {emiDetails?.featuredPlan?.templateCode != 'GLOBAL_THRESHOLD' && <div className="view-more-plans" onClick={() => openViewMoreEmiModal(true)}>
                  View Plans
                </div>
                }
              </div>
            )}
            {newDesignLuxe ? (
              <div className="tax-text" aria-label="Price inclusive of all taxes">
                Price inclusive of all taxes
              </div>
            ) : (
              ''
            )}
          </>
        )}
        {isAjioSuperCashPdpEnabled && superCashEarning && (
          <div className="supercash-container">
            <img
              src={ajioSuperCashConfig?.ajioCashCurrency?.currencySecondaryLogo}
              alt=""
              aria-hidden={true}
            />

            <span
              style={{ color: ajioSuperCashConfig?.walletPageConfig?.stripTextColor }}
              className="earn-text"
              aria-label={superCashEarningTemplate}
            >
              {superCashEarningTemplate}
            </span>
          </div>
        )}
        {!newDesignLuxe
          ? isEarlyAccessUser && !productData?.potentialPromotions?.length
            ? ''
            : displayGSTMessage(this, boolGST, displayformattedValue, colorVariant)
          : ''}
        <Freebies
          giftItemsList={freebiesItemsList}
          totalGiftCount={freebiesItemsCount}
          isDesktop={true}
        />
        {isPreBuzz || (isEarlyAccessUser && !productData?.potentialPromotions?.length) ? (
          <ProductPriceRevealV2
            priceRevealData={priceRevealV2Data}
            saveToCloset={this.saveToCloset}
            productData={sizeCode}
            data={productData}
            btnLabel={this.state.priveReveal}
            revealPriceCH={this.revealPriceCH}
            priceRevealSaveToClosetCH={() => {
              this.priceRevealSaveToClosetCH(sizeCode);
            }}
            priceRevealGoToClosetCH={this.priceRevealGoToClosetCH}
            sendGTMEvent={this.sendGTMEvent}
            newDesignLuxe={newDesignLuxe}
            earlyAccessData={earlyAccessData}
            currentStore={currentStore}
            bbsPriceForEarlyAccess={
              isEarlyAccessUser && !productData?.potentialPromotions?.length ? sellingPrice : null
            }
            isEarlyAccessUser={isEarlyAccessUser}
          />
        ) : null}
        <div className="trustMarkerImages">
          {trustmarkerImages.map(image => {
            return <img src={replaceWithJioCDN(image.url)} />;
          })}
        </div>
        {!productData?.potentialPromotions?.length ? (
          <BestPriceSectionInfo />
        ) : (
          <>
            <Feature featureName="offerPrice">
              <Variant id="0">
                <Promotions
                  offerPriceShow={false}
                  potentialPromotions={promotionalData}
                  categoryTags={categoryTags}
                  price={sellingPrice}
                  stockLevelStatus={stockLevelStatus}
                  showPriceReveal={isDuringSale}
                  isPriceReveal={isDuringSale || isPreBuzz}
                  newDesignLuxe={newDesignLuxe}
                  luxeEventPush={this.luxeEventPush}
                  isEarlyAccessUser={isEarlyAccessUser}
                />
              </Variant>
              <Variant id="1">
                <Promotions
                  offerPriceShow
                  potentialPromotions={promotionalData}
                  categoryTags={categoryTags}
                  price={sellingPrice}
                  stockLevelStatus={stockLevelStatus}
                  showPriceReveal={isDuringSale}
                  isPriceReveal={isDuringSale || isPreBuzz}
                  newDesignLuxe={newDesignLuxe}
                  luxeEventPush={this.luxeEventPush}
                  isEarlyAccessUser={isEarlyAccessUser}
                />
              </Variant>
            </Feature>
          </>
        )}
        {colorVariant && (
          <ColorVariant
            colorVariantData={colorVariant}
            viewRender={this.props.viewRender}
            metalPurity={metalPurity}
            newDesignLuxe={newDesignLuxe}
            luxeEventPush={this.luxeEventPush}
            productData={productData}
          />
        )}
        {sizeVariant && (
          <SizeVariant
            fetchStockList={this.fetchStockList}
            currentProductCode={currentProductCode}
            sizeVariantData={sizeVariant}
            hideSizes={hideSizes}
            appendDesc={appendDesc}
            sizeToolTip={sizeToolTip}
            sizeFormat={sizeFormat}
            viewRender={this.props.viewRender}
            handleGST={this.handleGST}
            oosStatus={oosStatus}
            showModal={this.props.showModal}
            _handleDealStockOverOnSizeClick={this._handleDealStockOverOnSizeClick}
            newFeatureFlag={this.props.newSizeRevampDesktopFlag}
            qualifierKey={qualifierKey}
            newDesignLuxe={newDesignLuxe}
            luxeEventPush={this.luxeEventPush}
            brandName={brandName}
            productName={name}
          />
        )}
        {/* sizeGuideDesktop && */ sizeChart.length > 0 && (
          <SizeGuide
            sizeRecommendPopUpData={this.props.sizeRecommendPopUpData}
            sizeRecommendData={this.props.sizeRecommendData}
            stockList={this.state.stockList}
            modelData={modelData}
            sizeGuide={sizeChart}
            image={productData.images[0].url}
            handleToggleInchCM={this.handleToggleInchCM}
            handleToggleInchCMIntConv={this.handleToggleInchCMIntConv}
            hideToggle={this.state.hideToggle}
            inches={this.state.inches}
            inchesIntConv={this.state.inchesIntConv}
            defaultUnit={this.state.defaultUnit}
            sizeType={this.newSize.sizeType}
            newFeatureFlag={this.props.newSizeRevampDesktopFlag}
            modelsize={productData.featureData}
            newDesignLuxe={newDesignLuxe}
            luxeEventPush={this.luxeEventPush}
            productData={productData}
            singleSizeRecommend={this.props?.singleRecommend}
          />
        )}
        <SizeRecommendation
          isDesktop
          brickName={brickName}
          brandName={brandName}
          brickCategory={brickCategory}
          brickSubCategory={brickSubCategory}
          sizeRecommendFetch={sizeRecommendFetch}
          sizes={(sizeVariant ?? []).map(el => ({ value: el.scDisplaySize })).filter(el => el)}
        />
        {!newDesignLuxe && this.props.stockMessage && (
          <div className="prod-stock-status">{this.props.stockMessage}</div>
        )}
        {showBrandSizeDesktopFlag && displayBrandStandardSize}
        {!this.props.selectedSizeStockLevel &&
          isDealStart &&
          !isDealEnd &&
          !this.state.showClaim &&
          dodStockStatus === 'inStock' &&
          dodStockNumber <= 10 && (
            <div className="prod-dod-stock-item" aria-label={`${dodStockNumber} item(s) left`}>
              {dodStockNumber} item(s) left
            </div>
          )}
        {dealClaim}

        {stockLevelStatus !== 'outOfStock' ? (
          <EstimatedDeliveryDate
            luxeEventPush={this.luxeEventPush}
            newDesignLuxe={newDesignLuxe}
            productData={this.props?.productData}
          />
        ) : (
          ''
        )}

        <div className="pdp-cart-buttons">
          {isComingSoonEnabled ? (
            isComingSoonProduct ? (
              <AddToCart
                productData={productData.code}
                selectedSizeName={selectedSizeName}
                data={productData}
                trustMarkerTxt={trustMarkerTxt}
                newDesignLuxe={newDesignLuxe}
                averageRating={productData?.ratingsResponse?.aggregateRating?.averageRating}
                numUserRatings={productData?.ratingsResponse?.aggregateRating?.numUserRatings}
                freebiesItemsCount={freebiesItemsCount}
              />
            ) : stockLevelStatus === 'outOfStock' ? (
              <div className="product-oos-block">
                <div className="oos-heading">
                  <span className="ic-pdp-oos" role="button" aria-label="OUT OF STOCK!" />
                  &nbsp; OUT OF STOCK!
                </div>
              </div>
            ) : (
              <AddToCart
                productData={productData.code}
                selectedSizeName={selectedSizeName}
                data={productData}
                trustMarkerTxt={trustMarkerTxt}
                newDesignLuxe={newDesignLuxe}
                averageRating={productData?.ratingsResponse?.aggregateRating?.averageRating}
                numUserRatings={productData?.ratingsResponse?.aggregateRating?.numUserRatings}
                freebiesItemsCount={freebiesItemsCount}
              />
            )
          ) : stockLevelStatus === 'outOfStock' ? (
            <div className="product-oos-block">
              <div className="oos-heading">
                <span className="ic-pdp-oos" role="button" aria-label="OUT OF STOCK!" />
                &nbsp; OUT OF STOCK!
              </div>
            </div>
          ) : (
            <AddToCart
              productData={productData.code}
              selectedSizeName={selectedSizeName}
              data={productData}
              trustMarkerTxt={trustMarkerTxt}
              newDesignLuxe={newDesignLuxe}
              averageRating={productData?.ratingsResponse?.aggregateRating?.averageRating}
              numUserRatings={productData?.ratingsResponse?.aggregateRating?.numUserRatings}
              freebiesItemsCount={freebiesItemsCount}
            />
          )}
          <SaveToCloset
            productData={sizeCode}
            data={productData}
            newDesignLuxe={newDesignLuxe}
            luxeEventPush={this.luxeEventPush}
            selectedSizeName={selectedSizeName}
          />
        </div>
        {!newDesignLuxe && dressToolVisibility && (
          <button
            style={{ border: 'unset', backgroundColor: 'white' }}
            className="dressToolBannerPDPDesktopButton"
            id="dressToolBannerPDPDesktopButton"
            onClick={this.handleDressToolClick}
            onKeyDown={this.handleDressToolKeyDown}
          >
            <img
              className="dressToolBannerPDPDesktop"
              style={{ maxHeight: '105px' }}
              src={replaceWithJioCDN(dressToolPdpBannerConfig?.imgUrl)}
              alt="AJIO Bra Genie"
              width="300px"
              height="105px"
            />
          </button>
        )}

        <section className="prod-desc">
          <h2 className="prod-heading" aria-label="Product Details">
            <strong>{(isBetterPdpEnabled && betterPdpTitle) || 'Product Details'}</strong>
          </h2>
          <div>
            <ul className="prod-list">
              {showNewVariant && !this.state.isSliderOpen && <> {defaultRendered}</>}
              {!showNewVariant && this.renderOldDesign(productData)}
              {!showNewVariant &&
                (this.props.selectedSizeCode ? (
                  <li className="detail-list">
                    {newDesignLuxe ? (
                      <span>
                        <span className="prod-code" aria-label="Product Code">
                          Product Code
                        </span>
                        :<span className="prod-code-value">{this.props.selectedSizeCode}</span>
                      </span>
                    ) : (
                      <span aria-label="Product Code: ">
                        Product Code: {this.props.selectedSizeCode}
                      </span>
                    )}
                  </li>
                ) : (
                  <li className="detail-list">
                    {newDesignLuxe ? (
                      <span>
                        <span className="prod-code" aria-label="Product Code">
                          Product Code
                        </span>
                        :
                        <span className="prod-code-value">
                          {currentProductCode || sizeVariant[0].code}
                        </span>
                      </span>
                    ) : (
                      <span aria-label="Product Code: ">
                        Product Code: {currentProductCode || sizeVariant[0].code}
                      </span>
                    )}
                  </li>
                ))}
              {productData.fnlColorVariantData.catDescription && (
                <li
                  className="detail-list brandDesc"
                  onClick={this.onActionClick}
                  aria-label={`About ${productData.fnlColorVariantData.brandName}`}
                >
                  About {productData.fnlColorVariantData.brandName}
                </li>
              )}

              {this.state.isSliderOpen && (
                <>
                  {showNewVariant && allSectionsRendered}
                  {showNewVariant ? <li key="product-code-info">
                    <div className="mandatory-list">
                      <div className="info-label" aria-label="Product Code">
                        Product Code
                      </div>
                      <div className="colon" aria-label=":">
                        :
                      </div>
                      <div className="title">
                        {this.props.selectedSizeCode || currentProductCode || sizeVariant[0].code}
                        <span className="other-info-subtitle"></span>
                      </div>
                    </div>
                  </li> : null}
                  {this._renderMandatoryInfo({
                    mandatoryInfo,
                    selectedProd: this.props.selectedSizeCode
                      ? this.props.selectedSizeCode
                      : sizeVariant[0].code,
                    variant: sizeVariant,
                    qualifierKeysForDesc
                  })}
                </>
              )}
              {showNewVariant && mandatoryInfo?.length && !this.state.isSliderOpen && (
                <li style={{ listStyleType: 'none' }}>
                  <div
                    className={`other-info-toggle ${newDesignLuxe ? 'plus-design' : ''}`}
                    onClick={() => this.setState({ isSliderOpen: true })}
                    aria-label="View More Details about product"
                    role="button"
                    tabIndex={0}
                  >
                    More Details
                    {!newDesignLuxe ? (
                      <span className="rilrtl-accordion-header__end-detail" aria-hidden="true">
                        <i className="ic-angle-down" />
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                </li>
              )}
              {!showNewVariant && mandatoryInfo?.length && !this.state.isSliderOpen && (
                <li style={{ listStyleType: 'none' }}>
                  <div
                    className="other-info-toggle toggle-float"
                    onClick={() => this.setState({ isSliderOpen: true })}
                    aria-label="More information about product"
                    role="button"
                    tabIndex={0}
                  >
                    Other information
                    <span className="rilrtl-accordion-header__end-detail" aria-hidden="true">
                      <i className="ic-angle-down" />
                    </span>
                  </div>
                </li>
              )}

              {showNewVariant && mandatoryInfo.length && this.state.isSliderOpen && (
                <li style={{ listStyleType: 'none' }}>
                  <div
                    className={`other-info-toggle ${newDesignLuxe ? 'minus-design' : ''}`}
                    onClick={() => this.setState({ isSliderOpen: false })}
                    aria-label="View less details about product"
                    role="button"
                    tabIndex={0}
                  >
                    Less details
                    {!newDesignLuxe ? (
                      <span className="rilrtl-accordion-header__end-detail" aria-hidden="true">
                        <i className="ic-angle-up" />
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                </li>
              )}
              {!showNewVariant && mandatoryInfo?.length && this.state.isSliderOpen && (
                <li style={{ listStyleType: 'none' }}>
                  <div
                    className="other-info-toggle toggle-float"
                    onClick={() => this.setState({ isSliderOpen: false })}
                    aria-label="View less details about product"
                    role="button"
                    tabIndex={0}
                  >
                    Less details
                    <span className="rilrtl-accordion-header__end-detail" aria-hidden="true">
                      <i className="ic-angle-up" />
                    </span>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </section>

        <Modal name="drop-at-store-popup" className="drop-at-store-popup" id="drop-at-store">
          <DropAtStoreInfo />
        </Modal>
        <Modal
          name="deal-out-of-stock"
          closeButton={false}
          disableOutsideClick
          className="dodModal"
        >
          <DealOfTheDayModal
            alt="Error icon"
            logo="/static/img/modalFail.png"
            header="Deal Stock is Over"
            subText="Sorry, deal is over. Although you can buy this product on an updated price"
            modalName="deal-out-of-stock"
            hideModal={this.props.hideModal}
            _isDodStockOver={this._isDodStockOver}
          />
        </Modal>
      </div>
    );
  }

  _renderMandatoryInfo(request) {
    let returnHtml = '';
    let { mandatoryInfo = [], selectedProd = '', variant = [], qualifierKeysForDesc } = request;

    let productMandate = [];
    let skuDetails = [];

    for (let idx = 0, len = variant.length; idx < len; idx++) {
      let { code = '', mandatoryInfo = [], variantOptionQualifiers } = variant[idx];

      if (code === selectedProd) {
        productMandate = mandatoryInfo;
        skuDetails = variantOptionQualifiers.reduce((acc, { name, qualifier, value }) => {
          const info = {
            title: '',
            key: ''
          };
          if (qualifierKeysForDesc.includes(qualifier)) {
            info.key = name;
            info.title = value;
            acc.push(info);
          }
          return acc;
        }, []);
        break;
      }
    }

    mandatoryInfo = productMandate.concat(skuDetails, mandatoryInfo);

    return mandatoryInfo.map(({ key = '', title = '', subTitle = '' }, index) => {
      return (
        <li key={`${key}other-info`} role='presentation'>
          <div className="mandatory-list"  aria-labelledby={`mandatory-list-info-label-${index} mandatory-list-title-${index}`}>
            {key && (
              <div className="info-label" id={`mandatory-list-info-label-${index}`} aria-hidden="true">
                {key}
              </div>
            )}
            {key && (
              <div className="colon" aria-hidden="true">
                :
              </div>
            )}
            {title && (
              <div className="title" id={`mandatory-list-title-${index}`} aria-hidden="true">
                {title}
                <span className="other-info-subtitle">{subTitle}</span>
              </div>
            )}
          </div>
        </li>
      );
    });
  }
}

const mapStateToProps = state => {
  const { flags = {} } = state;
  const hurryMessageInventoryCap = getHurryMsgInvCap(flags);
  let stockMessage = '';
  const { selectedSizeStockLevel = {} } = state.product;
  if (typeof selectedSizeStockLevel === 'object') {
    if (
      selectedSizeStockLevel.stockLevel <= hurryMessageInventoryCap &&
      selectedSizeStockLevel.stockLevel > 0
    ) {
      stockMessage = 'Hurry, Only few items left';
    }
    if (selectedSizeStockLevel.isLowStock) {
      stockMessage = `Hurry, Only ${selectedSizeStockLevel.stockLevel} items left`;
    }
  }
  const oosStatus =
    _get(state, 'product.productDetails.variantOptions', [])?.filter(
      each => each.stock.stockLevel === 0
    ) || [];
  return {
    earlyAccessFlag: getEarlyAccessFlag(flags),
    earlyAccessData: getEarlyAccessData(flags),
    disableGSTContent: getDisableGSTContentFlag(flags),
    defaultGSTMessage: getDefaultGSTMessage(flags),
    // priceRevealWebFlag: getPriceRevealWebFlag(flags),
    priceRevealV2WebFeatureFlag: getPriceRevealV2WebFeatureFlag(flags),
    priceRevealV2WebData: getPriceRevealWebData(flags),
    priceRevealLUXEFlag: getPriceRevealLUXEFlag(flags),
    metadata: state.metaData,
    selectedSizeCode: state.product.selectedSizeCode,
    selectedSizeName: state.product.selectedSizeName,
    dodSize: state.product.dodSize,
    selectedSizeStockLevel: _get(state, 'product.selectedSizeStockLevel.stockLevel', 0),
    stockMessage,
    discountPrice: state.product.discountPrice,
    originalPrice: state.product.originalPrice,
    cartOrNot: state.product.cartOrNot,
    discountPercentage: state.product.discountPercentage,
    sizeData: state.product.sizeData,
    sizeRecommendData: state.product.sizeRecommendData,
    sizeRecommendPopUpData: state.product.sizeRecommendPopUpData,
    oosStatus: oosStatus.map(each => each.code) || [],
    // newSizeFlag: getNewSizeRevampFlag(state.flags),
    // showBrandSizeFlag: getShowBrandSizeFlag(state.flags),
    newSizeRevampDesktopFlag: getNewSizeRevampDesktopFlag(state.flags),
    showBrandSizeDesktopFlag: getShowBrandSizeDesktopFlag(state.flags),
    sizeRecommendFlag: getSizeRecommendFlag(state.flags),
    trustMarkerTxt: _get(state, 'product.productDetails.fnlProductData.trustMarkerTxt', ''),
    currentStore: getCurrentStore(state),
    jioAddData: getJioAddData(state),
    productCatalog: getProductCatalog(state),
    singleRecommend: getSingleRecommend(state),
    enableRating: getEnableRating(state?.flags,state),
    showPDPRateSection: getShowPDPRateSection(state?.flags),
    storesForHidingMRP: getStoresForHidingMRP(state),
    ga4AjioEnable: getGA4AJIOEnable(state?.flags),
    freebiesItemsList: state?.product?.productDetails?.giftPromotion?.gifts || [],
    freebiesItemsCount: state?.product?.productDetails?.giftPromotion?.totalGiftCount || 0,
    enableGiftWithProduct: getGiftWithProductEnable(state.flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
    ratingsColor: getRatingsColorConfig(state?.flags),
    isComingSoonEnabled: getEnableComingSoonProducts(state?.flags),
    dressToolPdpBannerConfig: getDressToolPdpBannerConfig(state),
    isBetterPdpEnabled: getBetterPdpConfigFlag(state?.flags),
    isSectionOneTabViewEnabled: getSectionOneTabularViewFlag(state?.flags),
    isSectionTwoTabViewEnabled: getSectionTwoTabularViewFlag(state?.flags),
    maxLineForValue: getMaxLineForValueFlag(state?.flags),
    maxKeyValuePair: getMaxKeyValuePairFlag(state?.flags),
    betterPdpTitle: getBetterPdpTitleFlag(state?.flags),
    isSectionThreeTabViewEnabled: getSectionThreeTabularViewFlag(state?.flags),
    sectionOneData: getSectionOne(state),
    sectionTwoData: getSectionTwo(state),
    sectionThreeData: getSectionThree(state),
    sneakerHoodFeatureData: getSnekaerHoodData(state),
    isSneakerHoodOn: getBrickCodeList(state),
    brickCode: getBrickCode(state),
    featureData: getFeatureData(state),
    isAjioSuperCashPdpEnabled: getAjioSuperCashPdpEnable(state),
    ajioSuperCashConfig: getAjioSuperCashConfig(state?.flags),
    brickSubCategory: getProductSubCategory(state),
    sizeRecommendFetch: getSizeRecommendFetch(state),
    emiDiscountEnable: getEmiDiscountEnable(state) && getEmiDiscountEnableForPDP(state),
    emiDetails: getEmiDetails(state),
    emiTemplate: getEmiTemplate(state),
    emiThresholdAmount: getEmiThresholdAmount(state),
    offerCardOrder: getOfferCardOrder(state),
    serviceabilityDetails: getServiceabilityDetailsDetails(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: (name, config) => {
      dispatch(hideModal(name, config));
    },
    fetchSizeData: Obj => {
      dispatch(getSizeData(Obj));
    },
    sizeRecommend: (Obj, device) => dispatch(actions.getSizeRecommend(Obj, device)),
    addToWishlistApi: productId => dispatch(addProductToWishlist(productId)),
    setAdditionalInfo: data => dispatch(setAdditionalInfo(data)),
    initiateInitialFlag: () => dispatch(dressToolInitiateInitialFlag()),
    showATCDressModal: (name, config) => {
      dispatch(showDressToolModal(name, config));
    },
    hideATCDressModal: name => dispatch(hideDressToolModal(name))

  };
};

export default Description = connect(mapStateToProps, mapDispatchToProps)(Description);
